// extracted by css-extract-rspack-plugin
module.exports =  {"root":"NoTasks__root___xPOjx","illustration":"NoTasks__illustration___SzvTI","title":"NoTasks__title___FzjWV","description":"NoTasks__description___Kex9S"};